import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import {
  SERVICE_LABEL_ADVISOR,
  SERVICE_LABEL_WHOLESALER,
} from '../Landing/Helper/constants.js'

import './index.css'

function EmailSubscriptionCenterMenu({ storageProfile }) {
  const [currentMenuItem, setCurrentMenuItem] = useState('')

  useEffect(() => {
    let ticking = false

    window.addEventListener('scroll', () => {
      if (!ticking) {
        setTimeout(() => {
          const scrollPosition = window.pageYOffset

          let currentId = ''

          menuItems.forEach((menuItem) => {
            const element = document.querySelector('#' + menuItem.id)

            if (element && scrollPosition >= element.offsetTop - MAGIC_NUMBER) {
              currentId = menuItem.id
            }
          })

          if (currentId !== currentMenuItem) {
            setCurrentMenuItem(currentId)
          }

          ticking = false
        }, 200)

        ticking = true
      }
    })
  })

  const MAGIC_NUMBER = 180

  const menuItems = [
    {
      id: 'Your-subscriptions',
      label: 'Your Subscriptions',
      rule: true,
    },
    {
      id: 'Insights',
      label: 'Insights',
      rule: true,
    },
    {
      id: 'Products',
      label: 'Products',
      rule: true,
    },
    {
      id: 'Preferences',
      label: 'Preferences',
      rule:
        storageProfile.role === SERVICE_LABEL_ADVISOR ||
        storageProfile.role === SERVICE_LABEL_WHOLESALER,
    },
  ]

  const renderMenuItems = () => {
    return (
      <>
        {menuItems.map((menuItem) => {
          if (menuItem.rule) {
            return (
              <li key={menuItem.id} className={getClassNames(menuItem.id)}>
                <a
                  href={`#${menuItem.id}`}
                  aria-label={menuItem.label}
                  onClick={(e) => {
                    e.preventDefault()
                    scrollToElement(menuItem.id)
                  }}
                >
                  {menuItem.label}
                </a>
              </li>
            )
          }
        })}
      </>
    )
  }

  function scrollToElement(elementId) {
    setCurrentMenuItem(elementId)

    const element = document.querySelector('#' + elementId)

    element && window.scrollTo(0, element.offsetTop - MAGIC_NUMBER)
  }

  function getClassNames(elementId) {
    return (
      'List-item u-lg-textSizeMsrp1 u-sm-textSizeMsr u-sm-marginRight3gu' +
      ((!currentMenuItem && elementId === menuItems[0].id) ||
      elementId === currentMenuItem
        ? ' is-selected'
        : '')
    )
  }

  return (
    <div className="u-bgColorBrandDark">
      <div className="Grid u-sizeConstrained u-flexAlignItemsCenter u-flexJustifyBetween u-sm-sizeFull">
        <div className="u-textSizeMsrp4 u-lg-size9of12 u-lg-before3of12 u-sm-sizeFull">
          <ul className="List List--inline List--selectable List--reversed u-flexJustifyStart u-overflowX Esc-list-menu">
            {renderMenuItems()}
          </ul>
        </div>
      </div>
    </div>
  )
}

EmailSubscriptionCenterMenu.propTypes = {
  storageProfile: PropTypes.object,
}

export default EmailSubscriptionCenterMenu
